import {byHandlingAction, modifyState, reduceState} from "../FluxEnhancements";
import {ActionTypes} from "./Actions";
import {ReduceStore} from 'flux/utils';
import {AuthenticationDispatcher} from "../Dispatcher";

const reducer = reduceState(
    byHandlingAction(ActionTypes.LOGIN_REQUEST_RECEIVED).using((state, action) => {
        return modifyState(state, {
            displayAuthenticationModal: true,
            email: "",
            password: "",
        });
    }),
    byHandlingAction(ActionTypes.LOGIN_AUTHENTICATING).using((state, action) => {
        return modifyState(state, {
            displayAuthenticationModal: true,
            formDisabled: true,
            formInfoMessage: action.message
        });
    }),
    byHandlingAction(ActionTypes.LOGIN_AUTHENTICATION_INPUT_RECEIVED).using((state, action) => {
        return modifyState(state, {
            [action.formFieldName]: action.formFieldValue
        });
    }),
    byHandlingAction(ActionTypes.LOGIN_AUTHENTICATION_SUCCESS).using((state, action) => {
        return modifyState(state, {
            displayAuthenticationModal: false,
            formDisabled: false,
            email: "",
            password: "",
        });
    }),
    byHandlingAction(ActionTypes.LOGIN_AUTHENTICATION_FAILED).using((state, action) => {
        return modifyState(state, {
            displayAuthenticationModal:true,
            formErrorMessage: action.message,
            formDisabled: false,
            formInfoMessage: null
        });
    }),
);


class LoginFromHomePageStore extends ReduceStore {
    constructor() {
        super(AuthenticationDispatcher);
    }

    getInitialState() {
        return {};
    }
    reduce(state, action) {
        return reducer.reduce(state, action);
    }
}


export default new LoginFromHomePageStore();



/** WEBPACK FOOTER **
 ** ./src/shared_states/LoginFromHomePageRequest/LoginFromHomePageStore.js
 **/